/* eslint-disable no-undef */
document.addEventListener('DOMContentLoaded', function () {
  const sliders = document.querySelectorAll('.reviews-slider__swiper')

  if (!sliders.length) return

  sliders.forEach(function (slider) {
    const section = slider.closest('section')
    if (!section) return

    const sectionId = section.id

    const swiperInstance = new Swiper(slider, {
      spaceBetween: 20,
      slidesPerView: 1.2,
      centeredSlides: true,
      grabCursor: true,
      observer: true,
      observeParents: true,
      resizeObserver: true,
      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous review',
        nextSlideMessage: 'Next review'
      },
      pagination: {
        el: '#' + sectionId + ' .reviews-slider__pagination',
        clickable: true
      },
      navigation: {
        nextEl: '#' + sectionId + ' .reviews-slider__nav-btn--next',
        prevEl: '#' + sectionId + ' .reviews-slider__nav-btn--prev'
      },
      breakpoints: {
        750: {
          slidesPerView: 'auto',
          centeredSlides: false,
          spaceBetween: 20
        },
        990: {
          slidesPerView: 'auto',
          centeredSlides: false,
          spaceBetween: 24
        }
      }
    })

    // Store reference for potential cleanup
    slider.swiperInstance = swiperInstance
  })
})
